<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('nomor')">Nomor <i
                :class="currentSort === 'nomor' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('deskripsi')">Deskripsi <i
                :class="currentSort === 'deskripsi' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('aliasing')">Alias pada Profil <i
                :class="currentSort === 'aliasing' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('aliasing')">Alias pada SAP <i
                :class="currentSort === 'aliasing' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('last_modified_date')">Last Modified Date <i
                :class="currentSort === 'last_modified_date' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('last_modified_by')">Last Modified By <i
                :class="currentSort === 'last_modified_by' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('status')">Status <i
                :class="currentSort === 'status' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('catatan')">Catatan <i
                :class="currentSort === 'catatan' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)"><span class="fa fa-edit pointer ml20"></span></td>
            <td>{{ index + 1 }}</td>
            <td>{{ list.desc }}</td>
            <td>{{ list.alias_profile }}</td>
            <td>{{ list.alias_sap }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ list.update_by ? list.update_by : 'System' }}</td>
            <td :style="{ color: list.is_active === 'Active' ? 'green' : 'red' }">{{ list.is_active ? 'Aktif' : 'Tidak'
            }}
            </td>
            <td>{{ list.catatan }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <EditInternalMemo v-if="showModalEdit" :editData="editData" @closeModal="closeModal" class="notAll" />
  </div>
</template>
    
<script>
export default {
  components: {
    EditInternalMemo: () => import('@/components/masterdata/matrix/badan-usaha/edit/internal-memo.vue')
  },

  props: {
    'isEdit': Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        "nomor": "",
        "deskripsi": "",
        "alias_profil": "",
        "alias_sap": "",
        "last_modified_date": "",
        "last_modified_by": "",
        "status": "",
        "catatan": ""
      },
      data: [
        {
          "nomor": "1",
          "deskripsi": "Perseroan Terbatas (After 2007)",
          "alias_profil": "Internal Memo - PT",
          "alias_sap": "PT",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "2",
          "deskripsi": "Perseroan Terbatas (Before 2007)",
          "alias_profil": "Internal Memo - PT",
          "alias_sap": "PT",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "3",
          "deskripsi": "Perseroan Terbatas Terbuka (After 2007)",
          "alias_profil": "Internal Memo - PT TBK",
          "alias_sap": "PT TBK",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "4",
          "deskripsi": "Perseroan Terbatas Terbuka (Before 2007)",
          "alias_profil": "Internal Memo - PT TBK",
          "alias_sap": "PT TBK",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "5",
          "deskripsi": "Yayasan (After 2007)",
          "alias_profil": "Internal Memo - YAYASAN",
          "alias_sap": "YAYASAN",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "6",
          "deskripsi": "Yayasan (Before 2007)",
          "alias_profil": "Internal Memo - YAYASAN",
          "alias_sap": "YAYASAN",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "7",
          "deskripsi": "Commmanditaire Vennootschaap",
          "alias_profil": "Internal Memo - CV",
          "alias_sap": "CV",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "8",
          "deskripsi": "Bumdes",
          "alias_profil": "Internal Memo - BUMDES",
          "alias_sap": "BUMDES",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "9",
          "deskripsi": "Koperasi",
          "alias_profil": "Internal Memo - KOPERASI",
          "alias_sap": "KOPERASI",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "10",
          "deskripsi": "Forum / Perkumpulan Professional",
          "alias_profil": "Internal Memo - PERKUMPULAN",
          "alias_sap": "PERKUMPULAN",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "11",
          "deskripsi": "Private Limited - PTE LTD",
          "alias_profil": "Internal Memo - PTE LTD",
          "alias_sap": "PTE LTD",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "12",
          "deskripsi": "Limited - LTD",
          "alias_profil": "Internal Memo - LTD",
          "alias_sap": "LTD",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "13",
          "deskripsi": "Private  - PTE",
          "alias_profil": "Internal Memo - PTE",
          "alias_sap": "PTE",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "14",
          "deskripsi": "Corporation - CORP",
          "alias_profil": "Internal Memo - CORP",
          "alias_sap": "CORP",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "15",
          "deskripsi": "Incorporation - INC",
          "alias_profil": "Internal Memo - INC",
          "alias_sap": "INC",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        },
        {
          "nomor": "16",
          "deskripsi": "Lainnya",
          "alias_profil": "Internal Memo - LAINNYA",
          "alias_sap": ";",
          "last_modified_date": "-",
          "last_modified_by": "Systen",
          "status": "Active",
          "catatan": "-"
        }
      ]
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        desc: data.desc,
        alias_profile: data.alias_profile,
        alias_sap: data.alias_sap,
        updatedAt: data.updatedAt,
        is_active: data.is_active,
        note: data.note,
      }
      this.showModalEdit = true;
    },
    closeModal() {
      this.showModalEdit = false;
    },
  },

  computed: {
    badanUsaha() {
      const badan = this.$store.state.mdMatrixLegalStore.badan_usaha
      let filterBadan = badan.filter((b) => b.type_pendaftaran_id === 4 && b.bidang_usaha_id === 1)
      return filterBadan
    },
    sortedData() {
      return this.badanUsaha.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === 'desc') modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    }
  },

}
</script>